<template>
  <div
    class="insertTokenActions"
    :class="{'insertTokenActions--countdown': hasCountdown}"
  >
    <VButton
      id="insert-token-btn-not-received"
      variant="secondary"
      :disabled="hasCountdown || isDisabled"
      @click.native="triggerResendToken"
    >

      <div>
        {{resendTokenMessage}}

        <span v-if="hasCountdown">
          {{normalizedTimer}}
        </span>
      </div>

    </VButton>
  </div>
</template>

<script>
import VButton from '@/components/commons/VButton.vue';

export default {
  name: 'InsertTokenActions',
  components: {
    VButton,
  },

  props: {
    resendTokenMessage: {
      type: String,
      default: 'Reenviar código de validação',
    },
    countdownTotalTime: {
      type: Number,
      default: 25,
    },
    isDisabled: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      countdownTimer: 0,
      hasCountdown: true,
    };
  },

  computed: {
    normalizedTimer() {
      const normalizedTimerString = this.countdownTimer < 10
        ? `(00:0${this.countdownTimer})`
        : `(00:${this.countdownTimer})`;

      return normalizedTimerString;
    },
  },

  methods: {
    setUpCountdown() {
      this.countdownTimer = this.countdownTotalTime;

      setInterval(() => {
        this.countdownTimer--;

        if (this.countdownTimer < 0) {
          this.countdownTimer = this.countdownTotalTime;
          this.hasCountdown = false;
        }
      }, 1000);
    },

    triggerResendToken() {
      this.$emit('resendToken');
    },
  },

  created() {
    this.setUpCountdown();
  }
};
</script>

<style lang="scss" scoped>
.insertTokenActions {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  margin-top: 16px;

  &--countdown {
    & .button-component {

      &.button--secondary:disabled {
        font-size: 15px;
        color: var(--color-grey-4);
        background-color: initial;
        border-color: var(--color-grey-4);

        div {
          text-align: left;
        }
      }
    }
  }

  .button-component {

    &:not(:last-child) {
      margin-bottom: 16px;
    }

    &.button--secondary {
      color: var(--color-button-primary);

      div {
        display: flex;
        font-weight: 500;
        justify-content: center;
        line-height: 1.4;
        text-align: center;
        width: 100%;
      }

      & span {
        font-weight: 500;
        margin-left: 8px;
      }

      & svg {
        margin-right: 10px;
        max-height: 20px;
      }
    }
  }
}
</style>
